import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mainSurvey" }
const _hoisted_2 = { class: "q1" }
const _hoisted_3 = { class: "with-margin" }
const _hoisted_4 = { class: "mainSurvey-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_check_box = _resolveComponent("check-box")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.isCallSurvey ? _ctx.$t('survey_051_01_call') : _ctx.$t('survey_051_01')), 1),
      _createVNode(_component_check_box, {
        class: "checkbox",
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeValue($event))),
        label: _ctx.$t('survey_051_checkbox_0'),
        value: _ctx.checkedValues.find(x => x === _ctx.$t('survey_051_checkbox_0')) !== undefined
      }, null, 8, ["label", "value"]),
      _createVNode(_component_check_box, {
        class: "checkbox",
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeValue($event))),
        label: _ctx.$t('survey_051_checkbox_1'),
        value: _ctx.checkedValues.find(x => x === _ctx.$t('survey_051_checkbox_1')) !== undefined
      }, null, 8, ["label", "value"]),
      _createVNode(_component_check_box, {
        class: "checkbox",
        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeValue($event))),
        label: _ctx.$t('survey_051_checkbox_2'),
        value: _ctx.checkedValues.find(x => x === _ctx.$t('survey_051_checkbox_2')) !== undefined
      }, null, 8, ["label", "value"]),
      _createVNode(_component_check_box, {
        class: "checkbox",
        onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeValue($event))),
        label: _ctx.$t('survey_051_checkbox_3'),
        value: _ctx.checkedValues.find(x => x === _ctx.$t('survey_051_checkbox_3')) !== undefined
      }, null, 8, ["label", "value"]),
      _createVNode(_component_check_box, {
        class: "checkbox",
        onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeValue($event))),
        label: _ctx.$t('survey_051_checkbox_4'),
        value: _ctx.checkedValues.find(x => x === _ctx.$t('survey_051_checkbox_4')) !== undefined
      }, null, 8, ["label", "value"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Button, {
        class: "footer-button",
        size: 'large',
        text: _ctx.$t('previous'),
        type: 'outlined',
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goBack()))
      }, null, 8, ["text"]),
      _createVNode(_component_Button, {
        class: "footer-button",
        disabled: !_ctx.checkedValues.length,
        size: 'large',
        text: _ctx.$t('next'),
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.nextScreen()))
      }, null, 8, ["disabled", "text"])
    ])
  ]))
}